import {
  Container,
  Radio,
  RadioGroup,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
    Select,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Box,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  styled,
  Autocomplete,
  IconButton,
  Snackbar,
  Alert,
  Tooltip,
  InputAdornment,
  Card,
  CardContent,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect } from "react";
import { Modal as BootstrapModal } from "react-bootstrap";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: 20,
  padding: "8px 24px",
  textTransform: "none",
  fontWeight: 600,
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  },
}));


function StockIssuance() {
  const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(1);

  const [showUserGuide, setShowUserGuide] = useState(false);
  const [selectedType, setSelectedType] = useState("employee");
  const [data, setData] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showPersonModal, setShowPersonModal] = useState(false);
  const [showIssuanceModal, setShowIssuanceModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [inventoryItems, setInventoryItems] = useState([]);
  const [rows, setRows] = useState([]);
  const [issuanceCode, setIssuanceCode] = useState("");
  const [stockIssuanceId, setStockIssuanceId] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [issuanceList, setIssuanceList] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const apiUrl = process.env.REACT_APP_BASE_URL;
  const token = sessionStorage.getItem("token");

const fetchBranches = async () => {
  try {
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({}),
    });
    if (response.ok) setBranches(await response.json());
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
}; 

  // Fetch employees or students
  const fetchData = async (type) => {
    setIsLoading(true);
    try {
      const endpoint =
        type === "employee"
          ? "/Inventory/StockTransaction/ListEmployees"
          : "/Inventory/StockTransaction/ListStudents";
      const response = await fetch(`${apiUrl}${endpoint}?Branch_Id=${selectedBranchId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setData(Array.isArray(result) ? result : []);
      return result;
    } catch (error) {
      console.error(`Error fetching ${type} data:`, error);
      setData([]);
      setSnackbarMessage(`Failed to fetch ${type} data`);
      setSnackbarOpen(true);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch inventory items
  const fetchInventoryItems = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/Inventory/Item/GetInventoryItems?itemId=0&Branch_Id=${selectedBranchId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setInventoryItems(Array.isArray(result) ? result : []);
    } catch (error) {
      console.error("Error fetching inventory items:", error);
      setInventoryItems([]);
      setSnackbarMessage("Failed to fetch inventory items");
      setSnackbarOpen(true);
    }
  };

  // Fetch stock issuance list or details
  const fetchIssuanceDetails = async (stockIssuanceId = 0) => {
    setIsLoading(true);
    try {
      let endpoint;
      if (stockIssuanceId === 0) {
        endpoint = "/Inventory/StockTransaction/ListStockIssuance";
      } else {
        endpoint = `/Inventory/StockTransaction/GetStockIssuanceDetails/${stockIssuanceId}`;
      }

      const response = await fetch(`${apiUrl}${endpoint}?Branch_Id=${selectedBranchId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (stockIssuanceId === 0) {
        // Handle list of issuances
        setIssuanceList(Array.isArray(result) ? result : []);
      } else {
        // Handle single issuance details
        const { header, details } = result;
        setIssuanceCode(header.issuanceCode || "");
        setStockIssuanceId(header.stockIssuanceID);
        setSelectedType(header.issuedToType.toLowerCase());

        // Ensure data is fetched for the correct type
        await fetchData(header.issuedToType.toLowerCase());

        // Fetch person details based on issuedToID
        const person = data.find(
          (item) =>
            item[
            header.issuedToType === "Employee" ? "employeeId" : "studentId"
            ] === header.issuedToID
        ) || {
          // Fallback if person not found
          [header.issuedToType === "Employee" ? "employeeName" : "studentName"]:
            header.issuedToName,
          [header.issuedToType === "Employee" ? "employeeCode" : "admissionNo"]:
            "N/A",
          role: "N/A",
          mobile: "N/A",
          emailId: "N/A",
          className: "N/A",
          sectionName: "N/A",
          rollNo: "N/A",
          mobileNo: "N/A",
          emailID: "N/A",
        };
        setSelectedPerson(person);

        // Populate table rows from details
        setRows(
          details.map((item) => ({
            item: {
              itemId: item.itemID,
              itemName: item.itemName,
              itemCode: item.itemCode,
              purchasedPrice: 0, // Not provided in API
              currentBalance: "-", // Display hyphen for fetched issuances
              locationName: "N/A", // Not provided in API
            },
            issueQuantity: item.quantityIssued,
            sellingPrice: 0, // Not provided in API
            totalValue: 0, // Not provided in API
          }))
        );
        setIsSaved(true); // Disable editing
      }
    } catch (error) {
      console.error(
        `Error fetching ${stockIssuanceId === 0 ? "issuance list" : "issuance details"
        }:`,
        error
      );
      setSnackbarMessage(
        `Failed to fetch ${stockIssuanceId === 0 ? "issuance list" : "issuance details"
        }`
      );
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  // Save stock issuance
  const saveIssuance = async () => {
    if (!selectedPerson) {
      setSnackbarMessage("Please select an employee or student");
      setSnackbarOpen(true);
      return;
    }
    if (rows.length === 0 || !rows.every(isRowComplete)) {
      setSnackbarMessage("Please add at least one valid item with quantity");
      setSnackbarOpen(true);
      return;
    }
    setIsLoading(true);
    try {
      const payload = {
        issuedToType: selectedType === "employee" ? "Employee" : "Student",
        issuedToID:
          selectedPerson[
          selectedType === "employee" ? "employeeId" : "studentId"
          ],
        issuanceDate: new Date().toISOString().split("T")[0],
        items: rows.map((row) => ({
          itemID: row.item.itemId,
          quantityIssued: row.issueQuantity,
          unitSellPrice: row.sellingPrice,
        })),
      };
      const response = await fetch(
        `${apiUrl}/Inventory/StockTransaction/InsertStockIssuance?Branch_Id=${selectedBranchId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setIssuanceCode(result.issuanceCode || "");
      setStockIssuanceId(result.stockIssuanceId);
      setIsSaved(true);
      setSnackbarMessage(result.msg || "Stock issuance saved successfully");
      setSnackbarOpen(true);

      // Refresh inventory items after saving
      await fetchInventoryItems();
    } catch (error) {
      console.error("Error saving issuance:", error);
      setSnackbarMessage("Failed to save stock issuance");
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };


  // Print receipt
 // Print receipt
  const printReceipt = async () => {
    console.log("printReceipt started, stockIssuanceId:", stockIssuanceId);
    if (!stockIssuanceId) {
      console.log("No stock issuance ID, showing Snackbar");
      setSnackbarMessage("No stock issuance ID available for printing");
      setSnackbarOpen(true);
      return;
    }

    setIsLoading(true);
    try {
      console.log("Attempting to fetch receipt data from API");
      const response = await fetch(
        `${apiUrl}/Inventory/StockTransaction/PrintStockIssuanceReceipt/${stockIssuanceId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      console.log("API response status:", response.status);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("API response data:", result);
      const { header, details } = result;

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });
      const pageWidth = doc.internal.pageSize.getWidth();
      const margin = 15;
      const maxWidth = pageWidth - 2 * margin;

      // Process logo and PDF content in a single async block
      // (same logo-fetch/validate/fallback technique used in AdmReport's generatePDF)
      await new Promise((resolveAll) => {
        (async () => {
          let logoDataUrl = null;
          try {
            // Hardcoded logo as fallback
            const hardcodedLogo =
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBgYAAAAAUAAY+SkSAAAAAASUVORK5CYII=";
            logoDataUrl = hardcodedLogo;

            // Validate hardcoded image
            const img = new Image();
            const loadPromise = new Promise((resolve, reject) => {
              img.onload = () => {
                console.log("Hardcoded logo loaded successfully");
                resolve();
              };
              img.onerror = () => {
                console.error("Failed to load hardcoded logo image");
                reject(new Error("Failed to load hardcoded logo image"));
              };
              img.src = logoDataUrl;
            });
            await loadPromise;

            try {
              doc.setFillColor(240, 240, 240);
              doc.rect(margin - 2, 5, 34, 34, "F");
              doc.setFillColor(255, 255, 255);
              doc.rect(margin, 7, 30, 30, "F");
              doc.addImage(logoDataUrl, "PNG", margin + 2, 9, 26, 26);
              console.log("Hardcoded logo successfully added to PDF");
            } catch (error) {
              console.error("Error adding hardcoded logo to PDF:", error.message);
              throw error;
            }

            // Attempt API fetch for actual logo
            if (!token) {
              console.warn("No authentication token found in sessionStorage");
              throw new Error("No authentication token found");
            }

            const logoResponse = await fetch(`${apiUrl}/FeeReport/GetSchoolName`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: token,
              },
              body: JSON.stringify({}),
            });

            if (!logoResponse.ok) {
              console.error(
                `API fetch failed: ${logoResponse.status} ${logoResponse.statusText}`
              );
              throw new Error(`API error: ${logoResponse.status} ${logoResponse.statusText}`);
            }

            const apiData = await logoResponse.json();
            console.log("API response data:", JSON.stringify(apiData, null, 2));

            const logoImg = apiData?.[0]?.logoImg;
            if (!logoImg || typeof logoImg !== "string" || logoImg.trim() === "") {
              console.warn("No valid logo image found in API response");
              throw new Error("Invalid or missing logoImg in API response");
            }

            let cleanedBase64 = logoImg
              .replace(/^data:image\/[a-zA-Z]+;base64,/, "")
              .replace(/\s/g, "")
              .replace(/\n/g, "");
            const paddingLength = (4 - (cleanedBase64.length % 4)) % 4;
            cleanedBase64 += "=".repeat(paddingLength);

            const isValidBase64 = /^[A-Za-z0-9+/=]+$/.test(cleanedBase64);
            if (!isValidBase64) {
              console.error(
                "Invalid base64 string for logoImg:",
                cleanedBase64.substring(0, 100) + "..."
              );
              throw new Error("Invalid base64 string for logoImg");
            }

            logoDataUrl = `data:image/png;base64,${cleanedBase64}`;

            const apiImg = new Image();
            const apiLoadPromise = new Promise((resolve, reject) => {
              apiImg.onload = () => {
                console.log("API logo loaded successfully");
                resolve();
              };
              apiImg.onerror = () => {
                console.error("Failed to load API logo image");
                reject(new Error("Failed to load API logo image"));
              };
              apiImg.src = logoDataUrl;
            });
            await apiLoadPromise;

            try {
              doc.setFillColor(240, 240, 240);
              doc.rect(margin - 2, 5, 34, 34, "F");
              doc.setFillColor(255, 255, 255);
              doc.rect(margin, 7, 30, 30, "F");
              doc.addImage(logoDataUrl, "PNG", margin + 2, 9, 26, 26);
              console.log("API logo successfully added to PDF");
            } catch (error) {
              console.error("Error adding API logo to PDF:", error.message);
              throw error;
            }
          } catch (error) {
            console.error("Error fetching or processing logo:", error.message);
            doc.setFont("times", "bold");
            doc.setFontSize(10);
            doc.setTextColor(200, 0, 0);
            doc.text("Logo Failed", margin, 50);
            doc.setTextColor(0, 0, 0);
          }

          // Header — same fonts/colors as AdmReport
          doc.setFont("times", "bold");
          doc.setFontSize(18);
          doc.setTextColor(0, 51, 102);
          doc.text(header.branchName || "", pageWidth / 2, 14, { align: "center" });
          doc.setLineWidth(0.4);
          doc.setDrawColor(0, 51, 102);
          doc.line(margin + 40, 18, pageWidth - margin - 40, 18);
          doc.setFontSize(16);
          doc.text("Stock Issuance Receipt", pageWidth / 2, 24, { align: "center" });
          doc.setLineWidth(0.2);
          doc.setDrawColor(200, 200, 200);
          doc.line(margin + 65, 27, pageWidth - margin - 65, 27);
          doc.setFontSize(12);
          doc.setFont("times", "normal");
          doc.setTextColor(0, 0, 0);
          doc.text(`Issuance Code: ${header.issuanceCode || ""}`, pageWidth / 2, 35, {
            align: "center",
          });
          doc.text(`Date: ${header.issuanceDate || ""}`, pageWidth / 2, 41, {
            align: "center",
          });

          // Info block (same style as AdmReport's "Filters Applied" box)
         // Info block (same style as AdmReport's "Filters Applied" box)
          // Long values (like Branch name) are now wrapped with splitTextToSize
          // and the box height is calculated dynamically so nothing overlaps.
          const leftColX = margin + 5;
          const rightColX = pageWidth / 2 + 5;
          const colWidth = pageWidth / 2 - margin - 10; // usable width per column, with a gap between them

          doc.setFont("times", "normal");
          doc.setFontSize(10);

          const issuedToLines = doc.splitTextToSize(
            `Issued To: ${header.issuedToName || ""} (${header.issuedToType || ""})`,
            colWidth
          );
          const issuedToIdLines = doc.splitTextToSize(
            `Issued To ID: ${header.issuedToID ?? ""}`,
            colWidth
          );
          const branchLines = doc.splitTextToSize(
            `Branch: ${header.branchName || ""} (ID: ${header.branchID ?? ""})`,
            colWidth
          );
          const createdByLines = doc.splitTextToSize(
            `Created By: ${header.createdByName || ""} (ID: ${header.createdBy ?? ""})`,
            colWidth
          );
          const createdDateLines = doc.splitTextToSize(
            `Created Date: ${header.createdDate || ""}`,
            colWidth
          );
          const totalQtyLines = doc.splitTextToSize(
            `Total Quantity: ${header.totalQuantity ?? ""}`,
            colWidth
          );

          const lineHeight = 5;
          const leftColLineCount = issuedToLines.length + issuedToIdLines.length + branchLines.length;
          const rightColLineCount = createdByLines.length + createdDateLines.length + totalQtyLines.length;
          const maxLineCount = Math.max(leftColLineCount, rightColLineCount);

          const boxTopY = 48;
          const boxHeaderHeight = 6; // space for the "Details:" label
          const boxHeight = boxHeaderHeight + maxLineCount * lineHeight + 6;

          doc.setFillColor(245, 245, 245);
          doc.rect(margin, boxTopY, maxWidth, boxHeight, "F");

          doc.setFont("times", "bold");
          doc.setFontSize(10);
          doc.setTextColor(0, 51, 102);
          doc.text("Details:", leftColX, boxTopY + 6);

          doc.setFont("times", "normal");
          doc.setTextColor(0, 0, 0);

          let leftY = boxTopY + 6 + lineHeight;
          [...issuedToLines, ...issuedToIdLines, ...branchLines].forEach((line) => {
            doc.text(line, leftColX, leftY);
            leftY += lineHeight;
          });

          let rightY = boxTopY + 6 + lineHeight;
          [...createdByLines, ...createdDateLines, ...totalQtyLines].forEach((line) => {
            doc.text(line, rightColX, rightY);
            rightY += lineHeight;
          });

          // Table now starts right after the (variable-height) details box
          const tableStartY = boxTopY + boxHeight + 8;

         const tableData = details.map((item, index) => {
            const qty = item.quantityIssued ?? 0;
            const price = item.unitSellPrice ?? 0;
            const lineTotal = (qty * price).toFixed(2);
            return [
              (index + 1).toString(),
              item.itemCode || "-",
              item.itemName || "-",
              qty,
              price.toFixed(2),
              lineTotal,
            ];
          });

       doc.autoTable({
            head: [["S.No", "Item Code", "Item Name", "Quantity Issued", "Selling Price", "Total Amount"]],
            body: tableData,
            startY: 80,
            margin: { left: margin, right: margin },
            styles: {
              font: "times",
              fontSize: 10,
              cellPadding: 3,
              overflow: "linebreak",
              minCellHeight: 8,
              textColor: [33, 33, 33],
            },
            headStyles: {
              fillColor: [0, 51, 102],
              textColor: [255, 255, 255],
              fontSize: 10,
              fontStyle: "bold",
            },
            alternateRowStyles: { fillColor: [230, 240, 255] },
           columnStyles: {
              0: { cellWidth: 12, halign: "center" },
              1: { cellWidth: 30 },
              2: { cellWidth: 53 },
              3: { cellWidth: 28, halign: "center" },
              4: { cellWidth: 27, halign: "center" },
              5: { cellWidth: 30, halign: "center" },
            },
          });

          // Signature / terms footer
          const afterTableY = doc.lastAutoTable.finalY + 20;
          doc.setFont("times", "normal");
          doc.setFontSize(10);
          doc.setDrawColor(150, 150, 150);
          doc.line(margin, afterTableY, margin + 60, afterTableY);
          doc.text("Authorized Signature", margin, afterTableY + 5);
          doc.setFontSize(9);
          doc.setTextColor(120, 120, 120);
          doc.text(
            "Items issued are non-returnable unless authorized.",
            pageWidth - margin,
            afterTableY + 5,
            { align: "right" }
          );

          resolveAll();
        })();
      });

      // Save PDF as Blob, open, and print — same pattern as AdmReport
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const reportWindow = window.open(pdfUrl, "_blank");
      if (!reportWindow) {
        setSnackbarMessage("Please allow pop-ups to view the report.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error in printReceipt:", error);
      setSnackbarMessage("Failed to generate PDF receipt");
      setSnackbarOpen(true);
    } finally {
      console.log("printReceipt completed, setting isLoading to false");
      setIsLoading(false);
    }
  };

 useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);
  if (isMasterUser) fetchBranches();
  else setSelectedBranchId(sessionStorage.getItem("branchId"));
}, []);

  useEffect(() => {
  if (selectedBranchId) {
    fetchData(selectedType);
    fetchInventoryItems();
  }
}, [selectedType, selectedBranchId]);

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
    setSelectedPerson(null);
    setSearchTerm("");
    setRows([]);
    setIssuanceCode("");
    setStockIssuanceId(null);
    setIsSaved(false);
  };

  const handleSelectPerson = (person) => {
    setSelectedPerson(person);
    setShowPersonModal(false);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchIssuance = () => {
    fetchIssuanceDetails(0);
    setShowIssuanceModal(true);
  };

  const handleSelectIssuance = (issuance) => {
    fetchIssuanceDetails(issuance.stockIssuanceID);
    setShowIssuanceModal(false);
  };

  const handleCancel = () => {
    setSelectedPerson(null);
    setRows([]);
    setIssuanceCode("");
    setStockIssuanceId(null);
    setIsSaved(false);
    setSearchTerm("");
  };


  const filteredData = data.filter((item) => {
    if (!item) return false;
    const name =
      selectedType === "employee" ? item.employeeName : item.studentName;
    return name && name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const isRowComplete = (row) => {
    return row.item && row.issueQuantity > 0;
  };

  const addRow = () => {
    if (!selectedPerson) {
      setSnackbarMessage("Please select an employee or student");
      setSnackbarOpen(true);
      return;
    }
    if (inventoryItems.length === 0) {
      setSnackbarMessage("No inventory items available to issue");
      setSnackbarOpen(true);
      return;
    }
    if (rows.length > 0 && !isRowComplete(rows[rows.length - 1])) {
      setSnackbarMessage(
        "Please select an item and enter a valid quantity for the current row"
      );
      setSnackbarOpen(true);
      return;
    }
    setRows([
      ...rows,
      {
        item: null,
        issueQuantity: "",
        sellingPrice: 0,
        totalValue: 0,
      },
    ]);
  };

  const removeRow = (index) => {
    setRows(rows.filter((_, i) => i !== index));
  };

  const handleItemChange = (index, newItem) => {
    const updatedRows = [...rows];
    updatedRows[index] = {
      ...updatedRows[index],
      item: newItem,
      sellingPrice: newItem ? newItem.sellingPrice : 0,
      totalValue:
  newItem && updatedRows[index].issueQuantity
    ? newItem.sellingPrice * updatedRows[index].issueQuantity
    : 0,
    };
    setRows(updatedRows);
  };

  const handleQuantityChange = (index, value) => {
    const qty = value >= 0 ? Number(value) : 0;
    const updatedRows = [...rows];
    const maxQty = updatedRows[index].item
      ? updatedRows[index].item.currentBalance
      : 0;
    updatedRows[index].issueQuantity = qty > maxQty ? maxQty : qty;
    updatedRows[index].totalValue =
      updatedRows[index].issueQuantity * updatedRows[index].sellingPrice;updatedRows[index].totalValue =
  updatedRows[index].issueQuantity * updatedRows[index].sellingPrice;
    setRows(updatedRows);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container sx={{ padding: "20px", backgroundColor: "#f9fafb" }}>
      {isLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <CircularProgress />
        </Box>
      )}

   <Box
  sx={{
    border: "1px solid #CC9966",
    borderRadius: "8px",
    height: "60px",
    background: "linear-gradient(90deg, #beab6c 0%, #d4c28a 100%)",
    display: "flex",
    alignItems: "center",
    padding: "0 20px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    marginBottom: "20px",
    justifyContent: "space-between",
  }}
>
  {/* LEFT SIDE: radio group + info icon */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <RadioGroup row value={selectedType} onChange={handleTypeChange}>
      <FormControlLabel
        value="employee"
        control={<Radio />}
        label="Employee"
        sx={{
          "& .MuiFormControlLabel-label": {
            color: "white",
            fontWeight: "600",
          },
        }}
      />
      <FormControlLabel
        value="student"
        control={<Radio />}
        label="Student"
        sx={{
          "& .MuiFormControlLabel-label": {
            color: "white",
            fontWeight: "600",
          },
        }}
      />
    </RadioGroup>
    <InfoIcon onClick={() => setShowUserGuide(true)} style={{ opacity: 0.6, cursor: "pointer" }} />
  </Box>

  {/* RIGHT SIDE: branch dropdown */}
  {isMaster && (
    <Box sx={{ position: "relative" }}>
      <FormControl size="small" sx={{ width: 220 }}>
        <InputLabel>Branch</InputLabel>
        <Select
          value={selectedBranchId || ""}
          onChange={(e) => setSelectedBranchId(e.target.value)}
          label="Branch"
          startAdornment={
            <InputAdornment position="start">
              <LocationOnIcon sx={{ fontSize: 16, ml: 0.5 }} />
            </InputAdornment>
          }
        >
          {branches.map((branch) => (
            <MenuItem key={branch.branchId} value={branch.branchId}>
              {branch.branchName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )}
</Box> 

      <Dialog
        open={showUserGuide}
        onClose={() => setShowUserGuide(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
            backgroundColor: "#f9fafb",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(90deg, #1898c2 0%, #beab6c 100%)",
            color: "white",
            fontWeight: "bold",
            textAlign: "center",
            borderRadius: "12px 12px 0 0",
            py: 2,
          }}
        >
          Fee Deposit User Guide
        </DialogTitle>
        <DialogContent sx={{ padding: "24px" }}>
          <Typography
            variant="h6"
            sx={{
              color: "#1898c2",
              fontWeight: "600",
              mb: 2,
              mt: 1,
              textAlign: "center",
            }}
          >
            Quick Steps to Handle Stock Issuance
          </Typography>
          <Box
            component="ul"
            sx={{
              listStyleType: "none",
              padding: 0,
              "& li": {
                display: "flex",
                alignItems: "flex-start",
                mb: 1.5,
                fontSize: "0.9rem",
                color: "#333",
              },
              "& li::before": {
                content: '"\\2022"', // Bullet point
                color: "#1898c2",
                fontWeight: "bold",
                display: "inline-block",
                width: "1.5em",
                mr: 1,
                fontSize: "1.2rem",
              },
              "& strong": {
                margin: "0 0.2em", // Add spacing around strong tags
              },
            }}
          >
            <li><strong>Select</strong> employee or student type</li>
            <li><strong>Choose</strong> recipient from the list</li>
            <li><strong>Add items</strong> using the + button</li>
            <li><strong>Enter quantities</strong> (auto-validates against stock)</li>
            <li><strong>Save</strong> to complete issuance</li>
            <li><strong>Print</strong> receipt after saving</li>
            <li><strong>Search</strong> previous issuances by code</li>

          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <StyledButton
            onClick={() => setShowUserGuide(false)}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: "#1898c2",
              "&:hover": { backgroundColor: "#156f9a" },
              borderRadius: "8px",
              px: 4,
            }}
          >
            Close
          </StyledButton>
        </DialogActions>
      </Dialog>

      <Card
        sx={{
          marginBottom: "20px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          borderRadius: "8px",
          borderLeft: "4px solid #1898c2",
        }}
      >
        <CardContent>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#1898c2", marginBottom: "8px" }}
          >
            Welcome to Stock Issuance
          </Typography>
          <Typography variant="body1" sx={{ color: "textSecondary" }}>
            Select an employee or student to issue stock items. Use the table to
            add items, specify quantities, and save the issuance. You can also
            search for existing issuances using the Stock Issuance Code field.
          </Typography>
        </CardContent>
      </Card>

      <Box sx={{ marginBottom: "20px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setShowPersonModal(true)}
          disabled={isLoading || isSaved}
          sx={{ borderRadius: "4px" }}
        >
          Select {selectedType === "employee" ? "Employee" : "Student"}
        </Button>
      </Box>

      <Box sx={{ marginBottom: "20px" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#1898c2",
            marginBottom: "16px",
            textAlign: "center",
          }}
        >
          {selectedType === "employee" ? "Employee Details" : "Student Details"}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label={
                selectedType === "employee" ? "Employee Code" : "Admission No."
              }
              value={
                selectedPerson
                  ? selectedType === "employee"
                    ? selectedPerson.employeeCode
                    : selectedPerson.admissionNo
                  : "N/A"
              }
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Name"
              value={
                selectedPerson
                  ? selectedType === "employee"
                    ? selectedPerson.employeeName
                    : selectedPerson.studentName
                  : "Select an employee/student"
              }
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>
          {selectedType === "employee" ? (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Role"
                  value={selectedPerson ? selectedPerson.role : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Mobile"
                  value={selectedPerson ? selectedPerson.mobile : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  value={selectedPerson ? selectedPerson.emailId : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Class"
                  value={selectedPerson ? selectedPerson.className : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Section"
                  value={selectedPerson ? selectedPerson.sectionName : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Roll No."
                  value={selectedPerson ? selectedPerson.rollNo : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Mobile"
                  value={selectedPerson ? selectedPerson.mobileNo : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  value={selectedPerson ? selectedPerson.emailID : "N/A"}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </>
          )}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Stock Issuance Code"
              value={issuanceCode}
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleSearchIssuance}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ marginBottom: "20px" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#1898c2",
            marginBottom: "16px",
            textAlign: "center",
          }}
        >
          Issue Stock
        </Typography>
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: "400px",
            overflowY: "auto",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            borderRadius: "8px",
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#1898c2" }}>
                <TableCell
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                >
                  Item No.
                </TableCell>
                <TableCell
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                >
                  Item Name
                </TableCell>
                <TableCell
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                >
                  Purchase Price
                </TableCell>
                <TableCell
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                >
                  Available Qty
                </TableCell>
                <TableCell
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                >
                  Location
                </TableCell>
                <TableCell
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                >
                  Issue Qty
                </TableCell>
                <TableCell
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                >
                  Selling Price
                </TableCell>
                <TableCell
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                >
                  Total Value
                </TableCell>
                <TableCell
                  sx={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    padding: "12px",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={9}
                    sx={{ textAlign: "center", padding: "20px" }}
                  >
                    <Typography variant="body1" color="textSecondary">
                      No items added. Click "Add Item" to start issuing stock.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                rows.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#f5f5f5" : "white",
                      "&:hover": { backgroundColor: "#e0f7fa" },
                    }}
                  >
                    <TableCell sx={{ padding: "8px" }}>
                      <Autocomplete
                        options={inventoryItems}
                        getOptionLabel={(option) =>
                          option
                            ? `${option.itemCode} - ${option.itemName}`
                            : ""
                        }
                        value={row.item}
                        onChange={(event, newValue) =>
                          handleItemChange(index, newValue)
                        }
                        disabled={isSaved}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Item Code"
                            variant="outlined"
                            size="small"
                            helperText="Search and select an item by code or name"
                            sx={{ backgroundColor: "#e3f2fd" }}
                          />
                        )}
                        sx={{ minWidth: 200 }}
                      />
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <TextField
                        label="Item Name"
                        value={row.item ? row.item.itemName : ""}
                        variant="outlined"
                        size="small"
                        InputProps={{ readOnly: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <TextField
                        label="Purchase Price"
                        value={row.item ? row.item.purchasedPrice : ""}
                        variant="outlined"
                        size="small"
                        InputProps={{ readOnly: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <TextField
                        label="Available Quantity"
                        value={row.item ? row.item.currentBalance : ""}
                        variant="outlined"
                        size="small"
                        InputProps={{ readOnly: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <TextField
                        label="Location dosage"
                        value={row.item ? row.item.locationName || "N/A" : ""}
                        variant="outlined"
                        size="small"
                        InputProps={{ readOnly: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <TextField
                        type="number"
                        label="Issue Quantity"
                        value={row.issueQuantity}
                        onChange={(e) =>
                          handleQuantityChange(index, e.target.value)
                        }
                        variant="outlined"
                        size="small"
                        inputProps={{ min: 0 }}
                        helperText={
                          row.item
                            ? `Enter quantity (max: ${row.item.currentBalance})`
                            : "Select an item first"
                        }
                        error={
                          row.item &&
                          (row.issueQuantity < 0 ||
                            (row.item.currentBalance !== "-" &&
                              row.issueQuantity > row.item.currentBalance))
                        }
                        disabled={isSaved}
                        sx={{ width: 120, backgroundColor: "#e3f2fd" }}
                      />
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <TextField
                        label="Selling Price"
                        value={row.sellingPrice}
                        variant="outlined"
                        size="small"
                        InputProps={{ readOnly: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <TextField
                        label="Total Value"
                        value={row.totalValue}
                        variant="outlined"
                        size="small"
                        InputProps={{ readOnly: true }}
                        fullWidth
                      />
                    </TableCell>
                    <TableCell sx={{ padding: "8px" }}>
                      <Tooltip title="Remove this item">
                        <span>
                          <IconButton
                            color="error"
                            onClick={() => removeRow(index)}
                            disabled={isSaved}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ marginTop: "16px", textAlign: "center" }}>
          <Tooltip
            title={
              !selectedPerson
                ? "Select an employee or student to add items"
                : isSaved
                  ? "Issuance is saved and cannot be edited"
                  : "Add a new item to issue"
            }
          >
            <span>
              <Button
                variant="contained"
                color="success"
                startIcon={<AddCircleOutlineIcon />}
                onClick={addRow}
                disabled={!selectedPerson || isSaved}
                sx={{ borderRadius: "4px", padding: "8px 16px" }}
              >
                Add Item
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Box>

      <Box sx={{ textAlign: "center", marginTop: "20px" }}>
        <Tooltip
          title={
            !selectedPerson
              ? "Select an employee or student to save"
              : isSaved
                ? "Issuance is already saved"
                : "Save the stock issuance"
          }
        >
          <span>
            <Button
              variant="contained"
              color="primary"
              onClick={saveIssuance}
              disabled={!selectedPerson || isSaved}
              sx={{ marginRight: "10px", borderRadius: "4px" }}
            >
              Save
            </Button>
          </span>
        </Tooltip>
        <Tooltip
          title={
            !selectedPerson && rows.length === 0
              ? "No changes to cancel"
              : "Cancel and reset the form"
          }
        >
          <span>
            <Button
              variant="contained"
              color="error"
              onClick={handleCancel}
              disabled={!selectedPerson && rows.length === 0}
              sx={{ marginRight: "10px", borderRadius: "4px" }}
            >
              Cancel
            </Button>
          </span>
        </Tooltip>
        <Tooltip
          title={
            !issuanceCode
              ? "Save or select an issuance to enable printing"
              : "Print the receipt"
          }
        >
          <span>
            <Button
              variant="contained"
              color="secondary"
              onClick={printReceipt}
              disabled={!issuanceCode}
              sx={{ borderRadius: "4px" }}
            >
              Print
            </Button>
          </span>
        </Tooltip>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={
            snackbarMessage.includes("success")
              ? "success"
              : snackbarMessage.includes("Failed")
                ? "error"
                : "warning"
          } sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <BootstrapModal
        show={showPersonModal}
        onHide={() => setShowPersonModal(false)}
        centered
        dialogClassName="custom-modal"
      >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>
            Select {selectedType === "employee" ? "Employee" : "Student"}
          </BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          <TextField
            fullWidth
            label="Search"
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{ marginBottom: "20px", borderRadius: "4px" }}
          />
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "400px", overflowY: "auto" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>
                    {selectedType === "employee"
                      ? "Employee Code"
                      : "Admission No."}
                  </TableCell>
                  <TableCell>Name</TableCell>
                  {selectedType === "employee" ? (
                    <TableCell>Role</TableCell>
                  ) : (
                    <>
                      <TableCell>Class</TableCell>
                      <TableCell>Section</TableCell>
                    </>
                  )}
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={selectedType === "employee" ? 4 : 5}>
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {selectedType === "employee"
                          ? item.employeeCode
                          : item.admissionNo}
                      </TableCell>
                      <TableCell>
                        {selectedType === "employee"
                          ? item.employeeName
                          : item.studentName}
                      </TableCell>
                      {selectedType === "employee" ? (
                        <TableCell>{item.role}</TableCell>
                      ) : (
                        <>
                          <TableCell>{item.className}</TableCell>
                          <TableCell>{item.sectionName}</TableCell>
                        </>
                      )}
                      <TableCell>
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          onClick={() => handleSelectPerson(item)}
                          sx={{ borderRadius: "4px" }}
                        >
                          Select
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </BootstrapModal.Body>
      </BootstrapModal>

      <BootstrapModal
        show={showIssuanceModal}
        onHide={() => setShowIssuanceModal(false)}
        centered
        dialogClassName="custom-modal"
      >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Select Stock Issuance</BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "400px", overflowY: "auto" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Stock Issuance Code</TableCell>
                  <TableCell>Issued To</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {issuanceList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4}>No issuances found</TableCell>
                  </TableRow>
                ) : (
                  issuanceList.map((issuance, index) => (
                    <TableRow key={issuance.stockIssuanceID}>
                      <TableCell>{issuance.issuanceCode}</TableCell>
                      <TableCell>
                        {issuance.issuedToName} ({issuance.issuedToType})
                      </TableCell>
                      <TableCell>{issuance.issuanceDate}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          onClick={() => handleSelectIssuance(issuance)}
                          sx={{ borderRadius: "4px" }}
                        >
                          Select
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </BootstrapModal.Body>
      </BootstrapModal>
    </Container>
  );
}

export default StockIssuance;
